// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-icon-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.close-icon-container .icon-text {
  margin-top: 4px;
}
.close-icon-container .close-icon {
  font-size: 1.6em;
  margin: 0px 12px;
}

.stone-id-container {
  margin-bottom: 16px;
  display: flex;
  overflow: auto;
  padding-bottom: 4px;
  align-items: center;
}
.stone-id-container .stone-id {
  border: 1px solid #00a5c8;
  background-color: rgba(0, 165, 200, 0.0588235294);
  padding: 6px 8px;
  border-radius: 260px;
  margin: 2px 6px;
}

.stone-id-container::-webkit-scrollbar {
  height: 4px;
  cursor: pointer;
}

.stone-id-container:hover::-webkit-scrollbar {
  height: 8px;
  cursor: pointer;
}

.stone-id-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1019607843);
}

.stone-id-container:hover::-webkit-scrollbar-thumb {
  cursor: pointer;
}

.main-container {
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
}
.main-container .date-container {
  border-right: 1px solid #e5e5e5;
  padding: 0px 10px 0px 0px;
}
.main-container .time-container {
  padding: 0px 0px 2px 10px;
}
.main-container .time-container .time_container_div {
  height: 210px;
  overflow-y: scroll;
}
.main-container .time-container .time_container_div::-webkit-scrollbar {
  width: 0px;
}
.main-container .time-container .time_container_div::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1019607843);
}
.main-container .date-time-div {
  display: flex;
  justify-content: space-between;
}
.main-container .date-time-div .date-time {
  padding: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1019607843);
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.0392156863);
  line-height: 20px;
  width: 170px;
  text-align: center;
}
.main-container .date-time-div .disable_slot {
  opacity: 0.6;
}
.main-container p {
  margin: 12px 0px;
}

.confirm-btn {
  --border-radius: 70px;
}

.note-header {
  margin: 20px 0px 12px !important;
}

.note-text {
  background-color: rgba(0, 0, 0, 0.0392156863);
  border: 1px solid rgba(0, 0, 0, 0.1019607843);
  border-radius: 12px;
}

.excel_model_img_container,
.mail_model_img_container {
  display: inline-block;
  width: 56px;
  height: 56px;
  padding: 16px;
  border-radius: 50%;
  background-color: rgba(46, 125, 50, 0.1019607843);
}

.mail_model_img_container {
  background-color: rgba(187, 0, 27, 0.1019607843);
}

.excel_content_container {
  height: 34px;
  margin-bottom: 20px;
}

.excel_content {
  width: 224px;
  margin: auto;
}

.excel_email {
  color: #00a5c8;
}

.excel_btn {
  --border-radius: 260px;
}

.header {
  position: relative;
  display: flex;
  align-items: center;
}

.export {
  position: absolute;
  right: -20px;
}

.email_details {
  position: absolute;
  right: -65px;
}

ion-content::part(scroll) {
  overflow-y: hidden !important;
}

.popup_header {
  height: 56px;
}

.popup_header_ba {
  height: 44px;
  padding: 4px;
}

/*-----------CSS Ionic-----------*/
ion-col {
  padding: 0px;
}

ion-grid {
  padding: 12px;
}

ion-button {
  margin: 0px;
}

/*------------------- CSS Media -------------------*/
@media (min-width: 0px) and (max-width: 767px) {
  .book_appointment_title {
    font-size: 16px;
  }
  .close-icon-container_ba {
    justify-content: flex-start;
    margin-left: 20px;
  }
  .close-icon-container_ba .icon-text {
    margin-top: 4px;
    font-size: 12px;
  }
  .close-icon-container_ba .close-icon {
    position: absolute;
    right: 20px;
    top: -14px;
  }
  .main-container {
    border: none;
  }
  .main-container .date-container {
    border-right: none;
    padding: 0px;
    margin-bottom: 16px;
  }
  .main-container .date-container .date-header {
    margin-top: 0px;
  }
  .main-container .time-container {
    padding: 0px;
  }
  .main-container .time-container .time_container_div {
    height: 152px;
  }
  .main-container .time-container .time_header {
    margin-top: 0px;
  }
  .main-container .date-time-div {
    justify-content: space-around;
  }
  .main-container .date-time-div .date-time {
    line-height: 16px;
    width: 32vw;
    font-size: 12px;
  }
  .main-container .note-text {
    border-radius: 12px;
    font-size: 12px;
  }
  .stone-id-container {
    font-size: 10px;
  }
  .btn_container {
    display: flex;
    justify-content: center;
    flex-flow: column;
  }
}
@media (min-width: 0px) and (max-width: 575px) {
  .close-icon-container_ba {
    margin-left: 10px;
  }
  .excel_content_container {
    margin-bottom: 0px;
  }
  .excel_btn_sendnow {
    margin-top: 10px;
  }
}
.custom-modal-height {
  height: 170px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/book-appointment/book-appointment.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;AACJ;AAEE;EACE,gBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AADF;AAGE;EACE,yBAAA;EACA,iDAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AADJ;;AAKA;EACE,WAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,eAAA;AAFF;;AAKA;EACE,6CAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AASA;EACE,6BAAA;EACA,gCAAA;AANF;AAQE;EACE,+BAAA;EACA,yBAAA;AANJ;AAYE;EACE,yBAAA;AAVJ;AAYI;EACE,aAAA;EACA,kBAAA;AAVN;AAaI;EACE,UAAA;AAXN;AAkBI;EACE,6CAAA;AAhBN;AAqBE;EACE,aAAA;EACA,8BAAA;AAnBJ;AAqBI;EACE,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,6CAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAnBN;AAsBI;EACE,YAAA;AApBN;AA4BE;EACE,gBAAA;AA1BJ;;AA8BA;EACE,qBAAA;AA3BF;;AA8BA;EACE,gCAAA;AA3BF;;AA8BA;EACE,6CAAA;EACA,6CAAA;EACA,mBAAA;AA3BF;;AAoCA;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iDAAA;AAjCF;;AAoCA;EACE,gDAAA;AAjCF;;AAoCA;EACE,YAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,YAAA;EACA,YAAA;AAjCF;;AAoCA;EACE,cAAA;AAjCF;;AAoCA;EACE,sBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,YAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,YAAA;AAjCF;;AAoCA;EACE,6BAAA;AAjCF;;AAoCA;EACE,YAAA;AAjCF;;AAoCA;EACE,YAAA;EACA,YAAA;AAjCF;;AAoCA,kCAAA;AACA;EACE,YAAA;AAjCF;;AAoCA;EACE,aAAA;AAjCF;;AAoCA;EACE,WAAA;AAjCF;;AAoCA,oDAAA;AAEA;EACE;IACE,eAAA;EAlCF;EAqCA;IACE,2BAAA;IACA,iBAAA;EAnCF;EAqCE;IACE,eAAA;IACA,eAAA;EAnCJ;EAsCE;IACE,kBAAA;IACA,WAAA;IACA,UAAA;EApCJ;EAwCA;IACE,YAAA;EAtCF;EAuCE;IACE,kBAAA;IACA,YAAA;IACA,mBAAA;EArCJ;EAuCI;IACE,eAAA;EArCN;EAyCE;IACE,YAAA;EAvCJ;EA2CI;IACE,aAAA;EAzCN;EA4CI;IACE,eAAA;EA1CN;EA8CE;IACE,6BAAA;EA5CJ;EA8CI;IACE,iBAAA;IACA,WAAA;IACA,eAAA;EA5CN;EAgDE;IACE,mBAAA;IACA,eAAA;EA9CJ;EAkDA;IACE,eAAA;EAhDF;EAmDA;IACE,aAAA;IACA,uBAAA;IACA,iBAAA;EAjDF;AACF;AAoDA;EACE;IACE,iBAAA;EAlDF;EAqDA;IACE,kBAAA;EAnDF;EAsDA;IACE,gBAAA;EApDF;AACF;AAuDA;EACE,wBAAA;AArDF","sourcesContent":[".close-icon-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  .icon-text {\n    margin-top: 4px;\n  }\n\n  .close-icon {\n    font-size: 1.6em;\n    margin: 0px 12px;\n  }\n}\n\n.stone-id-container {\n  margin-bottom: 16px;\n  display: flex;\n  overflow: auto;\n  padding-bottom: 4px;\n  align-items: center;\n\n  .stone-id {\n    border: 1px solid #00a5c8;\n    background-color: #00a5c80f;\n    padding: 6px 8px;\n    border-radius: 260px;\n    margin: 2px 6px;\n  }\n}\n\n.stone-id-container::-webkit-scrollbar {\n  height: 4px;\n  cursor: pointer;\n}\n\n.stone-id-container:hover::-webkit-scrollbar {\n  height: 8px;\n  cursor: pointer;\n}\n\n.stone-id-container::-webkit-scrollbar-thumb {\n  background-color: #0000001a;\n}\n\n.stone-id-container:hover::-webkit-scrollbar-thumb {\n  cursor: pointer;\n}\n\n// .stone-id-container::-webkit-scrollbar-track {\n//   box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n// }\n\n.main-container {\n  border-top: 1px solid #e5e5e5;\n  border-bottom: 1px solid #e5e5e5;\n\n  .date-container {\n    border-right: 1px solid #e5e5e5;\n    padding: 0px 10px 0px 0px;\n\n    .date-header {\n    }\n  }\n\n  .time-container {\n    padding: 0px 0px 2px 10px;\n\n    .time_container_div {\n      height: 210px;\n      overflow-y: scroll;\n    }\n\n    .time_container_div::-webkit-scrollbar {\n      width: 0px;\n    }\n\n    // .time-container::-webkit-scrollbar-track {\n    //   box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    // }\n\n    .time_container_div::-webkit-scrollbar-thumb {\n      background-color: #0000001a;\n      // outline: 1px solid slategrey;\n    }\n  }\n\n  .date-time-div {\n    display: flex;\n    justify-content: space-between;\n\n    .date-time {\n      padding: 6px;\n      border: 1px solid #0000001a;\n      border-radius: 8px;\n      background-color: #0000000a;\n      line-height: 20px;\n      width: 170px;\n      text-align: center;\n    }\n\n    .disable_slot {\n      opacity: 0.6;\n    }\n  }\n\n  // .date-time-div .date-time:last-child {\n  //   margin-right: 8px;\n  // }\n\n  p {\n    margin: 12px 0px;\n  }\n}\n\n.confirm-btn {\n  --border-radius: 70px;\n}\n\n.note-header {\n  margin: 20px 0px 12px !important;\n}\n\n.note-text {\n  background-color: #0000000a;\n  border: 1px solid #0000001a;\n  border-radius: 12px;\n}\n\n// ::ng-deep .modal-wrapper.ion-overlay-wrapper.sc-ion-modal-md {\n//   width: 758px;\n//   height: 558px;\n//   border-radius: 20px;\n// }\n\n.excel_model_img_container,\n.mail_model_img_container {\n  display: inline-block;\n  width: 56px;\n  height: 56px;\n  padding: 16px;\n  border-radius: 50%;\n  background-color: #2e7d321a;\n}\n\n.mail_model_img_container {\n  background-color: #bb001b1a;\n}\n\n.excel_content_container {\n  height: 34px;\n  margin-bottom: 20px;\n}\n\n.excel_content {\n  width: 224px;\n  margin: auto;\n}\n\n.excel_email {\n  color: #00a5c8;\n}\n\n.excel_btn {\n  --border-radius: 260px;\n}\n\n.header {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.export {\n  position: absolute;\n  right: -20px;\n}\n\n.email_details {\n  position: absolute;\n  right: -65px;\n}\n\nion-content::part(scroll) {\n  overflow-y: hidden !important;\n}\n\n.popup_header {\n  height: 56px;\n}\n\n.popup_header_ba {\n  height: 44px;\n  padding: 4px;\n}\n\n/*-----------CSS Ionic-----------*/\nion-col {\n  padding: 0px;\n}\n\nion-grid {\n  padding: 12px;\n}\n\nion-button {\n  margin: 0px;\n}\n\n/*------------------- CSS Media -------------------*/\n\n@media (min-width: 0px) and (max-width: 767px) {\n  .book_appointment_title {\n    font-size: 16px;\n  }\n\n  .close-icon-container_ba {\n    justify-content: flex-start;\n    margin-left: 20px;\n\n    .icon-text {\n      margin-top: 4px;\n      font-size: 12px;\n    }\n\n    .close-icon {\n      position: absolute;\n      right: 20px;\n      top: -14px;\n    }\n  }\n\n  .main-container {\n    border: none;\n    .date-container {\n      border-right: none;\n      padding: 0px;\n      margin-bottom: 16px;\n\n      .date-header {\n        margin-top: 0px;\n      }\n    }\n\n    .time-container {\n      padding: 0px;\n      // height: 180px;\n      // overflow-y: scroll;\n\n      .time_container_div {\n        height: 152px;\n      }\n\n      .time_header {\n        margin-top: 0px;\n      }\n    }\n\n    .date-time-div {\n      justify-content: space-around;\n\n      .date-time {\n        line-height: 16px;\n        width: 32vw;\n        font-size: 12px;\n      }\n    }\n\n    .note-text {\n      border-radius: 12px;\n      font-size: 12px;\n    }\n  }\n\n  .stone-id-container {\n    font-size: 10px;\n  }\n\n  .btn_container {\n    display: flex;\n    justify-content: center;\n    flex-flow: column;\n  }\n}\n\n@media (min-width: 0px) and (max-width: 575px) {\n  .close-icon-container_ba {\n    margin-left: 10px;\n  }\n\n  .excel_content_container {\n    margin-bottom: 0px;\n  }\n\n  .excel_btn_sendnow {\n    margin-top: 10px;\n  }\n}\n\n.custom-modal-height {\n  height: 170px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
